import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../services/api";

export const useUpdateDistributorUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, body }) => {
      const isFormData = body instanceof FormData;
      const config = isFormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};
      const res = await api.put(`/distributors/user/update/${id}`, body, config);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["viewDistributorUsers"]);
      queryClient.invalidateQueries(["viewSingleDistributorUser"]);
    },
  });
};
